import { render, staticRenderFns } from "./BulkDialog.vue?vue&type=template&id=8a8203ea"
import script from "./BulkDialog.vue?vue&type=script&lang=js"
export * from "./BulkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports